let fetchMedications = fetch("https://my.inagene.com/api/v2/medication?token=9bCy4RyXGcHItJsxZuWO")
  .then(response => response.json())
  .then(json => json.data)
  .catch(error => {
    console.error('Failed to fetch API data:', error);
    return [];
  });

document.addEventListener("DOMContentLoaded", async () => {
  let medications = await fetchMedications;

  const searchSectionTitle = document.getElementById("searchSectionTitle");
  const searchBox = document.getElementById("searchBox");
  const searchOverlay = document.getElementById("searchOverlay");
  const searchReset = document.getElementById("searchReset");
  const searchOutput = document.getElementById("searchOutput");
  const searchResults = document.getElementById("searchResults");
  const searchResultsContainer = document.getElementById("searchResultsContainer");
  const searchNoResults = document.getElementById("searchNoResults");
  const searchLoading = document.getElementById("searchLoading");
  const searchCommonAgentClasses = document.getElementById("searchCommonAgentClasses");
  const searchCommonMedications = document.getElementById("searchCommonMedications");
  const commonAgentClassesContainer = document.getElementById("commonAgentClasses");
  const commonMedicationsContainer = document.getElementById("commonMedications");
  const autocompleteBox = document.getElementById("autocompleteBox");
  const filtersContainer = document.getElementById("filters");
  const classFilterContainer = document.getElementById("filtersClass");
  const agentClassFilterContainer = document.getElementById("filtersAgentClass");
  const productFilterContainer = document.getElementById("filtersProduct");
  const filterOverlay = document.getElementById("filterOverlay");
  const filterTagsContainer = document.getElementById("filterTags");
  const shopTests = document.getElementById("shopTests");
  const modalMedication = document.getElementById("modalMedication");
  const modalMedicationClose = document.getElementById("modalMedicationClose");
  const modalMedicationMain = document.getElementById("modalMedicationMain");
  const modalCompare = document.getElementById("modalCompare");
  const modalCompareClose = document.getElementById("modalCompareClose");
  const excludedProducts = ["general", "surgical-health", "test", "complete-health-q1-2025-subscription-update-version"]
  const productDisplayNames = {
    "cardiology": "Cardiovascular Health",
    "ultra": "Complete Health",
    "pain": "Pain & Mental Health",
    "womens-health": "Women's Health",
    "metabolic": "GLP-1 Insights Program"
  };
  const { classes, agents, products } = getUniqueFilters(medications);
  let currentFocus = -1;

  searchLoading.style.display = "none";
  searchCommonAgentClasses.style.display = "block";
  searchCommonMedications.style.display = "block";

  function getUniqueFilters(data) {
    const classSet = new Set();
    const agentSet = new Set();
    const productSet = new Set();

    data.forEach(item => {
      classSet.add(item.class);
      item.agent_class.split(",").forEach(s => agentSet.add(s.trim()));
      item.products.forEach(p => productSet.add(p));
    });

    return {
      classes: [...classSet],
      agents: [...agentSet],
      products: [...productSet]
    };
  }

  function createFilterCheckboxes(values, container, name) {
    values.sort();

    if (name === "class") {
      const groups = values.reduce((acc, val) => {
        const firstLetter = val.charAt(0).toUpperCase();
        if (!acc[firstLetter]) acc[firstLetter] = [];
        acc[firstLetter].push(val);
        return acc;
      }, {});

      Object.keys(groups).sort().forEach(letter => {
        const group = document.createElement("div");
        const groupTitle = document.createElement("h3");
        group.className = "medication-search__group";
        groupTitle.className = "medication-search__letter";
        groupTitle.textContent = letter;
        group.appendChild(groupTitle);

        groups[letter].forEach(val => {
          const label = document.createElement("label");
          label.className = "medication-search__label";
          label.innerHTML = `
            <input class="medication-search__checkbox" type="checkbox" name="${name}" value="${val}" />
            <span>${val}</span>
          `;
          group.appendChild(label);
        });
        container.appendChild(group);
      });

    } else if (name === "products") {
      values.forEach(val => {
        if (excludedProducts.includes(val)) {
          return;
        }

        const label = document.createElement("label");
        label.className = "medication-search__label h2";
        label.innerHTML = `
          <input class="medication-search__checkbox" type="checkbox" name="${name}" value="${val}" />
          <span>${productDisplayNames[val] || val}</span>
        `;
        container.appendChild(label);
      });
    } else {
      values.forEach(val => {
        const label = document.createElement("label");
        label.className = "medication-search__label";
        label.innerHTML = `
          <input class="medication-search__checkbox" type="checkbox" name="${name}" value="${val}" />
          <span>${val}</span>
        `;
        container.appendChild(label);
      });
    }
  }

  function getCheckedboxValues(name) {
    return [...document.querySelectorAll(`input[name="${name}"]:checked`)].map(cb => cb.value);
  }

  // function updateCheckboxStates(matchedData) {
  //   const available = getUniqueFilters(matchedData);
  //   updateCheckboxGroup("class", available.classes);
  //   updateCheckboxGroup("agent_class", available.agents);
  //   updateCheckboxGroup("products", available.products);
  // }

  // function updateCheckboxGroup(name, validValues) {
  //   const checkboxes = document.querySelectorAll(`input[name="${name}"]`);
  //   checkboxes.forEach(cb => {
  //     const isChecked = cb.checked;
  //     const isValid = validValues.includes(cb.value);
  //     cb.disabled = !isChecked && !isValid;
  //   });
  // }

  function updateActiveFilterGroups() {
    document.querySelectorAll(".medication-search__filter-group").forEach(group => {
      const checkboxes = group.querySelectorAll("input[type=checkbox]");
      const isActive = [...checkboxes].some(cb => cb.checked);
      group.classList.toggle("medication-search__filter-group--active", isActive);
    });
  }

  function renderActiveFilters(classes, agents, products) {
    filterTagsContainer.innerHTML = "";

    const allFilters = [
      ...classes.map(val => ({ type: "class", value: val })),
      ...agents.map(val => ({ type: "agent_class", value: val })),
      ...products.map(val => ({ type: "products", value: val }))
    ];

    if (allFilters.length === 0) {
      // filterTagsContainer.innerHTML = "<em>No filters applied.</em>";
      return;
    }

    allFilters.forEach(filter => {
      const tag = document.createElement("span");
      tag.className = "medication-search__filter-tag";

      if (filter.type === "products") {
        tag.innerHTML = `${productDisplayNames[filter.value] || filter.value} <span class="medication-search__filter-icon"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L12 12" stroke="black" stroke-width="2"/><path d="M12 1L1 12" stroke="black" stroke-width="2"/></svg></span>`;
        tag.title = `Remove filter: ${productDisplayNames[filter.value] || filter.value}`;
      } else {
        tag.innerHTML = `${filter.value} <span class="medication-search__filter-icon"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L12 12" stroke="black" stroke-width="2"/><path d="M12 1L1 12" stroke="black" stroke-width="2"/></svg></span>`;
        tag.title = `Remove filter: ${filter.value}`;
      }
      
      tag.addEventListener("click", () => {
        const checkbox = document.querySelector(`input[name="${filter.type}"][value="${filter.value}"]`);
        if (checkbox) checkbox.checked = false;
        updateActiveFilterGroups();
        filterResults();
      });
      filterTagsContainer.appendChild(tag);
    });
  }

  function filterResults() {
    const query = searchBox.value.trim().toLowerCase();
    const selectedClasses = getCheckedboxValues("class");
    const selectedAgents = getCheckedboxValues("agent_class");
    const selectedProducts = getCheckedboxValues("products");
    const tests = document.querySelectorAll(".medication-search__shop-test");

    let summaries = [];
    if (query) summaries.push(`Query: "${query}"`);
    if (selectedClasses.length) summaries.push(`Classes: "${selectedClasses.join(", ")}"`);
    if (selectedAgents.length) summaries.push(`Agents: "${selectedAgents.join(", ")}"`);
    if (selectedProducts.length) summaries.push(`Products: "${selectedProducts.join(", ")}"`);

    const summary = summaries.length ? `Search: {${summaries.join(", ")}}` : "";

    if (selectedClasses.length === 0 && selectedAgents.length === 0 && selectedProducts.length === 1) {
      tests.forEach(test => {
        if (test.dataset.test === selectedProducts[0]) {
          test.style.display = "block";
        } else {
          test.style.display = "none";
        }
      });
    } else {
      tests.forEach(test => {
        if (test.dataset.test === "all") {
          test.style.display = "block";
        } else {
          test.style.display = "none";
        }
      });
    }

    const hasSearch = !!query;
    const hasFilters = selectedClasses.length || selectedAgents.length || selectedProducts.length;

    // Return nothing if no search and no filters
    if (!hasSearch && !hasFilters) {
      searchSectionTitle.style.display = "block";
      searchResults.style.display = "none";
      searchResultsContainer.innerHTML = "";
      searchNoResults.style.display = "none";
      searchCommonAgentClasses.style.display = "block";
      searchCommonMedications.style.display = "block";
      filterTagsContainer.innerHTML = "";
      shopTests.style.display = "none";
      // updateCheckboxStates(medications);
      return;
    }

    const matches = medications.filter(item => {
      const matchesSearch =
        !query ||
        item.drug_name.toLowerCase().includes(query) ||
        item.brand_names.toLowerCase().includes(query) ||
        item.class.toLowerCase().includes(query) ||
        item.agent_class.toLowerCase().includes(query) ||
        item.products.some(p => p.toLowerCase().includes(query));

      const matchesClass = !selectedClasses.length || selectedClasses.includes(item.class);

      const matchesAgent = !selectedAgents.length || item.agent_class.split(",").map(s => s.trim()).some(agent => selectedAgents.includes(agent));

      const matchesProduct = !selectedProducts.length || item.products.some(p => selectedProducts.includes(p));

      return matchesSearch && matchesClass && matchesAgent && matchesProduct;
    });

    searchResultsContainer.innerHTML = "";

    if (matches.length === 0) {
      searchSectionTitle.style.display = "none";
      searchResults.style.display = "none";
      searchNoResults.style.display = "block";
      searchCommonAgentClasses.style.display = "none";
      searchCommonMedications.style.display = "none";
      shopTests.style.display = "none";
    } else {
      searchSectionTitle.style.display = "none";
      searchResults.style.display = "block";
      searchNoResults.style.display = "none";
      searchCommonAgentClasses.style.display = "none";
      searchCommonMedications.style.display = "none";
      shopTests.style.display = "block";
  
      matches.forEach(item => {
        const medication = document.createElement("div");
        const medicationName = document.createElement("div");
        const medicationBrandNames = document.createElement("div");
        const medicationIdentifier = document.createElement("div");
        const medicationAgentClass = document.createElement("div");
        const agentClasses = item.agent_class.split(", ").slice(0, 2);
        
        medication.className = "medication-search__medication"; 
        medicationName.className = "medication-search__name";
        medicationName.textContent = item.drug_name;
        medicationBrandNames.className = "medication-search__brand-names";
        medicationBrandNames.textContent = item.brand_names;
        medicationIdentifier.className = "medication-search__identity";
        medicationAgentClass.className = "medication-search__agent-class";
        medicationAgentClass.textContent = agentClasses.join(", ");
  
        medicationIdentifier.appendChild(medicationName);
        medicationIdentifier.appendChild(medicationBrandNames);
        medication.appendChild(medicationIdentifier);
        medication.appendChild(medicationAgentClass);
        medication.addEventListener("click", () => showModalMedication(item));
        searchResultsContainer.appendChild(medication);
      });
    }
    
    renderActiveFilters(selectedClasses, selectedAgents, selectedProducts);
    logSearchToAPI(summary);
    // updateCheckboxStates(matches);
  }

  function searchMedication(term) {
    const grouped = {
      drug_match: [],
      first_agent_class: [],
      agent_class: [],
      class: [],
      products: []
    };

    const seenDrugs = new Set();
    const seenAgentClasses = new Set();
    const seenClasses = new Set();
    const seenProducts = new Set();

    medications.forEach(item => {
      const lowerTerm = term.toLowerCase();

      const nameMatch =
        item.drug_name.toLowerCase().includes(lowerTerm) ||
        item.brand_names.toLowerCase().includes(lowerTerm);

      // Handle drug match
      if (nameMatch && !seenDrugs.has(item.drug_name)) {
        grouped.drug_match.push(item);
        seenDrugs.add(item.drug_name);

        // Add first agent_class
        const firstAgent = item.agent_class.split(",").map(a => a.trim())[0];
        if (firstAgent && !seenAgentClasses.has(firstAgent)) {
          grouped.first_agent_class.push(firstAgent);
          seenAgentClasses.add(firstAgent);
        }

        // Add class
        if (item.class && !seenClasses.has(item.class)) {
          grouped.class.push(item.class);
          seenClasses.add(item.class);
        }

        // Add products
        item.products.forEach(p => {
          if (!seenProducts.has(p)) {
            grouped.products.push(p);
            seenProducts.add(p);
          }
        });
      }

      // Match individual agent_class terms
      item.agent_class.split(",").map(a => a.trim()).forEach(agent => {
        if (agent.toLowerCase().includes(lowerTerm) && !seenAgentClasses.has(agent)) {
          grouped.agent_class.push(agent);
          seenAgentClasses.add(agent);
        }
      });

      // Match class
      if (item.class.toLowerCase().includes(lowerTerm) && !seenClasses.has(item.class)) {
        grouped.class.push(item.class);
        seenClasses.add(item.class);
      }

      // Match product names
      item.products.forEach(product => {
        if (product.toLowerCase().includes(lowerTerm) && !seenProducts.has(product)) {
          grouped.products.push(product);
          seenProducts.add(product);
        }
      });
    });

    return grouped;
  }

  function positionAutocompleteBox() {
    const rect = searchBox.getBoundingClientRect();
    autocompleteBox.style.top = `${rect.bottom + window.scrollY}px`;
    autocompleteBox.style.left = `${rect.left + window.scrollX}px`;
    autocompleteBox.style.width = `${rect.width}px`;
  }

  function clearAutocompleteBox() {
    autocompleteBox.style.display = "none";
    autocompleteBox.innerHTML = "";
    currentFocus = -1;
  }

  function renderAutocompleteBox(grouped) {
    let html = "";
    currentFocus = -1;

    // Full drug match
    grouped.drug_match.forEach((item, index) => {
      const autoAgentClasses = item.agent_class.split(", ").slice(0, 2);

      html += `
        <div class="medication-search__suggestion" data-type="drug_name" data-value="${item.drug_name}" data-index="${index}">
          <div class="medication-search__identity">
            <div class="medication-search__name"><strong>${item.drug_name}</strong></div>
            <div class="medication-search__brand-names">${item.brand_names}</div>
          </div>
          <div class="medication-search__agent-class">${autoAgentClasses.join(", ")}</div>
        </div>
      `;
    });

    // First agent class (from drug match)
    grouped.first_agent_class.forEach((agent, index) => {
      html += `
        <div class="medication-search__suggestion medication-search__suggestion--agent-class" data-type="agent_class" data-value="${agent}" data-index="${index}">
          <div>All ${agent} medications</div>
        </div>
      `;
    });

    // Agent class (from direct match)
    grouped.agent_class.forEach((agent, index) => {
      html += `
        <div class="medication-search__suggestion medication-search__suggestion--agent-class" data-type="agent_class" data-value="${agent}" data-index="${index}">
          <div>All ${agent} medications</div>
        </div>
      `;
    });

    // Class
    grouped.class.forEach((c, index) => {
      html += `
        <div class="medication-search__suggestion" data-type="class" data-value="${c}" data-index="${index}">
          <div>All ${c}</div>
        </div>
      `;
    });

    // Products
    grouped.products.forEach((product, index) => {
      if (excludedProducts.includes(product)) {
        return;
      }

      html += `
        <div class="medication-search__suggestion medication-search__suggestion--product" data-type="products" data-value="${product}" data-index="${index}">
          <div class="medication-search__identity"><strong>${productDisplayNames[product] || product}</strong></div>
          <div class="medication-search__agent-class">Inagene Test</div>
        </div>
      `;
    });

    autocompleteBox.innerHTML = html;
    autocompleteBox.style.display = "block";
    positionAutocompleteBox();
  }


  function addActive(index) {
    removeActive();
    const items = document.querySelectorAll("#autocompleteBox .medication-search__suggestion");
    if (items.length === 0) return;
    if (index >= items.length) index = 0;
    if (index < 0) index = items.length - 1;
    currentFocus = index;
    const item = items[currentFocus];
    item.classList.add("medication-search__suggestion--active");
    item.scrollIntoView({ block: "nearest" });
  }

  function removeActive() {
    const items = document.querySelectorAll("#autocompleteBox .medication-search__suggestion");
    items.forEach(el => el.classList.remove("medication-search__suggestion--active"));
  }

  function showModalMedication(medication) {
    const tests = document.querySelectorAll(".medication-modal__test");
    const filters = document.querySelectorAll(".medication-modal__test-button");

    tests.forEach(test => {
      if (medication.products.includes(test.dataset.test)) {
        test.style.display = "block";
      } else {
        test.style.display = "none";
      }
    });

    filters.forEach(filter => {
      filter.addEventListener("click", () => {
        document.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
        const checkbox = [...document.querySelectorAll(`input[name="products"]`)].find(cb => cb.value === filter.dataset.filter);
        if (checkbox) checkbox.checked = true;
        searchBox.value = "";
        searchReset.style.display = "none";
        modalMedication.style.display = "none";
        modalMedicationClose.style.display = "none";
        filtersContainer.parentElement.style.display = "block";
        searchOutput.style.display = "block";
        updateActiveFilterGroups();
        filterResults();
      });
    });

    modalMedicationMain.innerHTML = `
      <div class="medication-modal__identifier">
        <h2 class="medication-modal__name h1">${medication.drug_name}</h2>
        <p class="medication-modal__brand-names">${medication.brand_names}</p>
      </div>

      <div class="medication-modal__drug-class">
        <p class="medication-modal__section-heading subtitle"><strong>Drug Class</strong></p>
        <div class="medication-modal__drug-classes" id="modalMedicationDrugClasses"></div>
      </div>

      <div class="medication-modal__agent-class">
        <p class="medication-modal__section-heading subtitle"><strong>Treatment Category</strong></p>
        <div class="medication-modal__agent-classes" id="modalMedicationAgentClasses"></div>
        <button class="medication-modal__more-agent-classes" id="modalMedicationMoreAgentClasses"><span class="medication-modal__more">+ More</span><span class="medication-modal__less>- Less</span></button>
      </div>
    `;

    const modalDrugClasses = document.getElementById("modalMedicationDrugClasses");
    const modalAgentClasses = document.getElementById("modalMedicationAgentClasses");
    const modalMedicationMoreAgentClasses = document.getElementById("modalMedicationMoreAgentClasses");
    const modalCompare = document.getElementById("modalMedicationCompare");

    const dClass = document.createElement("button");
    dClass.className = "medication-modal__drug-class-tag";
    dClass.textContent = medication.class;
    modalDrugClasses.appendChild(dClass);

    dClass.addEventListener("click", () => {
      document.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
      const checkbox = [...document.querySelectorAll(`input[name="class"]`)].find(cb => cb.value === medication.class);
      if (checkbox) checkbox.checked = true;
      searchBox.value = "";
      searchReset.style.display = "none";
      modalMedication.style.display = "none";
      modalMedicationClose.style.display = "none";
      filtersContainer.parentElement.style.display = "block";
      searchOutput.style.display = "block";
      updateActiveFilterGroups();
      filterResults();
    });

    const agentClassArray = medication.agent_class.split(", ");
    const maxVisible = 3;

    agentClassArray.forEach((agent, index) => {
      const aClass = document.createElement("button");
      aClass.className = "medication-modal__agent-class-tag";
      aClass.textContent = agent;

      if (index >= maxVisible) {
        aClass.classList.add("medication-modal__agent-class-tag--hidden"); 
      }

      aClass.addEventListener("click", () => {
        document.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
        const checkbox = [...document.querySelectorAll(`input[name="agent_class"]`)].find(cb => cb.value === agent);
        if (checkbox) checkbox.checked = true;
        searchBox.value = "";
        searchReset.style.display = "none";
        modalMedication.style.display = "none";
        modalMedicationClose.style.display = "none";
        filtersContainer.parentElement.style.display = "block";
        searchOutput.style.display = "block";
        updateActiveFilterGroups();
        filterResults();
      });

      modalAgentClasses.appendChild(aClass);
    });

    if (agentClassArray.length > maxVisible) {
      modalMedicationMoreAgentClasses.style.display = "inline-block";
    } else {
      modalMedicationMoreAgentClasses.style.display = "none";
    }

    modalMedicationMoreAgentClasses.addEventListener("click", () => {
      const hiddenItems = modalAgentClasses.querySelectorAll(".medication-modal__agent-class-tag.medication-modal__agent-class-tag--hidden");
      hiddenItems.forEach(el => el.classList.toggle("medication-modal__agent-class-tag--visible"));

      modalMedicationMoreAgentClasses.classList.toggle("medication-modal__more-agent-classes--active");
    });

    modalCompare.addEventListener("click", () => {
      const tests = document.querySelectorAll(".compare-modal__test");

      tests.forEach(test => {
        if (medication.products.includes(test.dataset.test)) {
          test.style.display = "block";
        } else {
          test.style.display = "none";
        }
      });
      showModalCompare();
    });

    searchOutput.style.display = "none";
    modalMedication.style.display = "block";
    modalMedicationClose.style.display = "inline-flex";
    filtersContainer.parentElement.style.display = "none";
  }
  
  function showModalCompare() {
    modalCompare.style.display = "block";
    document.body.classList.add("no-scroll");
  }

  // function logSearchToAPI(search) {
  //   const url = `https://corsproxy.io/?${encodeURIComponent(
  //     "https://portal-staging-ca.inagene.com/api/search/history"
  //   )}`;

  //   fetch(url, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       source: "inagene.com",
  //       text: search
  //     })
  //   }).then(r => {
  //     if (!r.ok) throw new Error("Network response was not ok");
  //     return r.json();
  //   })
  //   .then(data => {
  //     // console.log("Search logged via proxy:", data);
  //   })
  //   .catch(err => {
  //     console.error("Error logging search (via proxy):", err);
  //   });
  // }

  function logSearchToAPI(search) {
    fetch("https://portal-staging-ca.inagene.com/api/search/history", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        source: "inagene.com",
        text: search 
      })
    }).then(response => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.json();
    }).then(data => {
      // console.log("Search logged:", data);
    }).catch(err => {
      console.error("Error logging search:", err);
    });
  }

  createFilterCheckboxes(classes, classFilterContainer, "class");
  createFilterCheckboxes(agents, agentClassFilterContainer, "agent_class");
  createFilterCheckboxes(products, productFilterContainer, "products");

  searchBox.addEventListener("input", () => {
    const term = searchBox.value.trim().toLowerCase();

    if (term.length > 0) {
      searchReset.style.display = "block";
    } else {
      searchReset.style.display = "none";
    }

    if (!term) return clearAutocompleteBox();
    
    const results = searchMedication(term);
    renderAutocompleteBox(results);
  });

  searchBox.addEventListener("keydown", event => {
    const items = document.querySelectorAll("#autocompleteBox .medication-search__suggestion");

    if (event.key === "ArrowDown") {
      event.preventDefault();
      currentFocus++;
      addActive(currentFocus);
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      currentFocus--;
      addActive(currentFocus);
    } else if (event.key === "Enter") {
      if (currentFocus > -1 && items[currentFocus]) {
        event.preventDefault();
        items[currentFocus].click();
      } else {
        event.preventDefault();
        // const searchTerm = searchBox.value.trim();
        // if (searchTerm) {
        //   logSearchToAPI(searchTerm);
        // }
        modalMedication.style.display = "none";
        modalMedicationClose.style.display = "none";
        filtersContainer.parentElement.style.display = "block";
        searchOutput.style.display = "block";
        filterResults();
        searchBox.blur();
        clearAutocompleteBox();
        searchOverlay.classList.remove("medication-search__s-overlay--active");
        document.body.classList.remove("no-scroll");
      }
    } else if (event.key === "Escape") {
      searchBox.blur();
      clearAutocompleteBox();
      searchOverlay.classList.remove("medication-search__s-overlay--active");
      document.body.classList.remove("no-scroll");
      
    }
  });

  searchBox.addEventListener("focus", () => {
    searchOverlay.classList.add("medication-search__s-overlay--active");
    document.body.classList.add("no-scroll");
  });

  searchBox.addEventListener("blur", () => {
    setTimeout(() => {
      searchOverlay.classList.remove("medication-search__s-overlay--active");
      document.body.classList.remove("no-scroll");
    }, 200);
  });

  searchReset.addEventListener("click", () => {
    searchBox.value = "";
    searchReset.style.display = "none";
    document.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
    modalMedication.style.display = "none";
    modalMedicationClose.style.display = "none";
    filtersContainer.parentElement.style.display = "block";
    searchOutput.style.display = "block";
    updateActiveFilterGroups();
    filterResults();
    clearAutocompleteBox();
  });

  if (searchCommonAgentClasses.dataset.agentClasses && searchCommonAgentClasses.dataset.agentClasses !== "") {
    searchCommonAgentClasses.dataset.agentClasses.split(", ").forEach(agent => {
      if (agents.includes(agent)) {
        const tag = document.createElement("span");
        tag.className = "medication-search__common-tag";
        tag.textContent = agent;
        tag.addEventListener("click", () => {
          const checkbox = document.querySelector(`input[name="agent_class"][value="${agent}"]`);
          if (checkbox) checkbox.checked = true;
          searchBox.value = "";
          searchReset.style.display = "none";
          updateActiveFilterGroups();
          filterResults();
        });
        commonAgentClassesContainer.appendChild(tag);
      }
    });
  };

  if (searchCommonMedications.dataset.medications && searchCommonMedications.dataset.medications !== "") {
    searchCommonMedications.dataset.medications.split(", ").forEach(med => {
      const common = med.trim().toLowerCase();
      const match = medications.filter(item => {
        const matchesSearch = item.drug_name.toLowerCase().includes(common);
        
        return matchesSearch;
      });

      if (match.length !== 0) {   
        const commonMedication = document.createElement("div");
        const commonMedicationIdentifier = document.createElement("div");
        const commonMedicationName = document.createElement("div");
        const commonMedicationBrandNames = document.createElement("div");
        const commonMedicationAgentClass = document.createElement("div");
        const commonAgentClasses = match[0].agent_class.split(", ").slice(0, 2);
        
        commonMedication.className = "medication-search__medication"; 
        commonMedicationName.className = "medication-search__name";
        commonMedicationName.textContent = match[0].drug_name;
        commonMedicationBrandNames.className = "medication-search__brand-names";
        commonMedicationBrandNames.textContent = match[0].brand_names;
        commonMedicationIdentifier.className = "medication-search__identity";
        commonMedicationAgentClass.className = "medication-search__agent-class";
        commonMedicationAgentClass.textContent = commonAgentClasses.join(", ");
  
        commonMedicationIdentifier.appendChild(commonMedicationName);
        commonMedicationIdentifier.appendChild(commonMedicationBrandNames);
        commonMedication.appendChild(commonMedicationIdentifier);
        commonMedication.appendChild(commonMedicationAgentClass);
        commonMedication.addEventListener("click", () => showModalMedication(match[0]));
        commonMedicationsContainer.appendChild(commonMedication);
      }
    });
  };

  modalMedicationClose.addEventListener("click", () => {
    modalMedication.style.display = "none";
    modalMedicationClose.style.display = "none";
    filtersContainer.parentElement.style.display = "block";
    searchOutput.style.display = "block";
  });
  
  modalCompareClose.addEventListener("click", () => {
    modalCompare.style.display = "none";
    document.body.classList.remove("no-scroll");
  });

  document.body.addEventListener("click", e => {
    if (e.target.classList.contains("medication-search__suggestion")) {
      const type = e.target.dataset.type;
      const value = e.target.dataset.value;

      if (type === "drug_name") {
        const medication = medications.find(d => d.drug_name === value);
        if (medication) {
          showModalMedication(medication);
        }
        searchBox.value = value;
        searchReset.style.display = "block";
      } else {
        document.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
        const checkbox = [...document.querySelectorAll(`input[name="${type}"]`)].find(cb => cb.value === value);
        if (checkbox) checkbox.checked = true;
        searchBox.value = "";
        searchReset.style.display = "none";
        modalMedication.style.display = "none";
        modalMedicationClose.style.display = "none";
        filtersContainer.parentElement.style.display = "block";
        searchOutput.style.display = "block";
      }

      updateActiveFilterGroups();
      filterResults();
      clearAutocompleteBox();
    } else if (e.target !== searchBox && !autocompleteBox.contains(e.target)) {
      clearAutocompleteBox();
    }
  });

  document.querySelectorAll('input[type="checkbox"]').forEach(cb => {
    cb.addEventListener("change", () => {
      updateActiveFilterGroups();
      filterResults();
    });
  });
  
  document.querySelectorAll(".medication-search__dropdown-close").forEach(button => {
    button.addEventListener("click", () => {
      const anyOpen = [...document.querySelectorAll(".medication-search__filter-group")]
      .some(group => group.classList.contains("medication-search__filter-group--open"));

      if (anyOpen) {
        document.querySelectorAll(".medication-search__filter-group").forEach(g => {
          g.classList.remove("medication-search__filter-group--open");
        });
        filtersContainer.classList.remove("medication-search__filters--open");
        filterOverlay.classList.remove("medication-search__f-overlay--active");
        document.body.classList.remove("no-scroll");
      }
    });
  });

  document.querySelectorAll(".medication-search__filter").forEach(button => {
    button.addEventListener("click", () => {
      const parent = button.parentElement;
      const isOpen = parent.classList.contains("medication-search__filter-group--open");
      filtersContainer.classList.add("medication-search__filters--open");
      document.querySelectorAll(".medication-search__filter-group").forEach(g => {
        g.classList.remove("medication-search__filter-group--open");
      });
      if (!isOpen) {
        parent.classList.add("medication-search__filter-group--open");
        filterOverlay.classList.add("medication-search__f-overlay--active");
        document.body.classList.add("no-scroll");
      } else {
        filtersContainer.classList.remove("medication-search__filters--open");
        filterOverlay.classList.remove("medication-search__f-overlay--active");
        document.body.classList.remove("no-scroll");
      }
    });
  });
  
  document.addEventListener("click", (e) => {
    const isInsideFilterGroup = e.target.closest(".medication-search__filter-group");
    const isFilterButton = e.target.classList.contains("medication-search__button");
    const isSearchBox = e.target === searchBox || searchBox.contains(e.target);
    const isAutocomplete = autocompleteBox.contains(e.target);

    if (!isInsideFilterGroup && !isFilterButton && !isSearchBox && !isAutocomplete) {
      document.querySelectorAll(".medication-search__filter-group").forEach(g => {
        g.classList.remove("medication-search__filter-group--open");
      });
      filtersContainer.classList.remove("medication-search__filters--open");
      filterOverlay.classList.remove("medication-search__f-overlay--active");
      if (
        modalCompare.style.display !== "block" 
      ) {
        document.body.classList.remove("no-scroll");
      }
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      const anyOpen = [...document.querySelectorAll(".medication-search__filter-group")]
        .some(group => group.classList.contains("medication-search__filter-group--open"));

      if (anyOpen) {
        document.querySelectorAll(".medication-search__filter-group").forEach(g => {
          g.classList.remove("medication-search__filter-group--open");
        });
        filtersContainer.classList.remove("medication-search__filters--open");
        filterOverlay.classList.remove("medication-search__f-overlay--active");
        document.body.classList.remove("no-scroll");
      }
    }
  });
});